import React from 'react';

import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@telus-uds/components-web';
import Edit from '@telus-uds/palette-allium/build/web/icons/Edit';

import { getLocale } from '../../misc';
import request from '../../utils/request';

import DisableButton from './disable';
import DeleteButton from './delete';

const Actions = ({ userData, fetchUsers }) => {
  const history = useHistory();
  const locale = getLocale();
  const { email: currentUserEmail } = request.getProfile();

  const { id, first_name: firstName, last_name: lastName, email } = userData;
  const username = `${firstName} ${lastName}`;

  const handleEditUser = () => {
    history.push(`/${locale}/users/${id}`);
  };

  return (
    <div style={{ display: 'flex' }}>
      <Tooltip content="Edit">
        <Button
          icon={Edit}
          accessibilityLabel="Edit"
          onPress={handleEditUser}
          variant={{ text: true }}
        />
      </Tooltip>
      {email !== currentUserEmail && (
        <>
          <DisableButton email={email} name={username} fetchData={fetchUsers} />
          <DeleteButton id={id} fetchData={fetchUsers} />
        </>
      )}
    </div>
  );
};
Actions.propTypes = {
  userData: PropTypes.shape({
    id: PropTypes.number,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string
  }).isRequired,
  fetchUsers: PropTypes.func.isRequired
};
export default Actions;
